import {
  Button,
  danger,
  Input,
  Modal,
  modalHandler,
  success,
  SwitchInput,
  updateList,
  UploadImageCard,
  useCustomForm,
  useEffect,
} from "@";
import { saveAdminPopupScreen } from "../utils/api";
import { defaultValues, schema } from "../utils/validation";
import { popUpShowingSectionOptions } from "../utils/options";

const Form = ({ data, setData, edit }) => {
  // Destructure methods and properties from useCustomForm hook
  const {
    reset,
    watch,
    errors,
    register,
    setValue,
    getValues,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
  } = useCustomForm(defaultValues, schema);

  // Function to clear the form fields
  const clearForm = () => {
    reset(defaultValues);
  };

  // Function to handle form submission
  const submit = async () => {
    try {
      const { data: newValue } = await saveAdminPopupScreen(getValues());
      setData(updateList(data, newValue));
      success("تم الحفظ بنجاح");
      modalHandler();
      clearForm();
    } catch (error) {
      danger("حدث خطأ أثناء حفظ البيانات");
    }
  };

  // Effect to reset the form when edit data changes
  useEffect(() => {
    reset(edit);
  }, [edit]);

  return (
    <>
      {/* Modal component to display the form */}
      <Modal close={clearForm} title={watch("id") ? "تعديل" : "اضافة"}>
        <form onSubmit={handleSubmit(submit)} className="relative p-2 md:p-5">
          {/* Input field for URL */}
          <Input
            style="mb-5"
            label="الرابط"
            error={errors.url}
            input={register("url")}
            placeholder="https://domainname.com"
          />

          {/* Select input for choosing the display section */}
          <Input
            type="select"
            value={watch("section")}
            style="mb-7"
            noEmptyOption
            label="مكان العرض"
            error={errors.section}
            list={popUpShowingSectionOptions}
            input={register("section")}
          />

          {/* UploadImageCard component for uploading an image */}
          <UploadImageCard
            show={true}
            star={!watch("id")}
            title="صورة النافذة"
            src={getValues("imageUrl")}
            success={isSubmitSuccessful}
            error={errors.image?.message}
            upload={(file) => setValue("image", file)}
          />

          {/* Checkbox for active status */}
          <div className="mb-5">
            <SwitchInput
              label="نشط"
              checked={watch("isActive")}
              change={(value) => setValue("isActive", value)}
            />
          </div>

          {/* Submit button */}
          <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
        </form>
      </Modal>
    </>
  );
};

export default Form;
